module.exports = __webpack_public_path__ + "static/media/onboarding_szamlak.62a5aba3.svg";